const React = require("react");

const StoreBudgetsForm = React.createClass({
    render() {
        return (<div>
            Store budget template file:&nbsp;
            <a href={this.props.SampleFileURL} target="_blank">
                Click here to download
            </a>
        </div>);
    }
});

module.exports = StoreBudgetsForm;


// WEBPACK FOOTER //
// ./src/components/metadata/StoreBudgetsForm.jsx